import React, { useState, useRef } from "react";

const AccordionItem = ({ title, id, content, index, options }) => {
  const [setActive, setActiveState] = useState(false);

  const trigger = useRef(null);
  const panel = useRef(null);

  function toggleAccordion() {
    if (setActive === true) {
      setActiveState(false);
      trigger.current.ariaExpanded = false;
      trigger.current.classList.remove("active");
      panel.current.hidden = true;
    } else {
      setActiveState(true);
      trigger.current.ariaExpanded = true;
      trigger.current.classList.add("active");
      panel.current.hidden = false;
    }
  }

  const panelId = id ? "panel-" + index + "-" + id : "panel-" + index;
  const accordionId = id
    ? "accordion-" + index + "-" + id
    : "accordion-" + index;

  return (
    <>
      <h3 className="accordion__btn">
        <button
          aria-expanded={false}
          className={`accordion__trigger`}
          aria-controls={panelId}
          id={accordionId}
          onClick={toggleAccordion}
          ref={trigger}
        >
          <span className="accordion__title">
            {title} <span className="accordion__icon" />
          </span>
        </button>
      </h3>
      <div
        id={panelId}
        role="region"
        aria-labelledby={accordionId}
        className="accordion__panel"
        ref={panel}
        hidden={true}
      >
        <div>
          <div
            className={"accordion__content"}
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default AccordionItem;
